<!-- Search and NEW -->
<div class="flexie-auto-grid p-b-20">
  <div>
    <h3>Search</h3>
    <app-ui-search [(SearchCriteria)]="CRITERIALOOKUP" (componentOutput)="fetchSearchResult($event)"
      searchURL="claim/registration/search" itemsPerPage='20'></app-ui-search>
  </div>
  <div class="text-a-right">
    <button *ngIf="false" nz-button [nzType]="'primary'" (click)="NewRegistration()">
      <i nz-icon nzType="plus"  nzTheme="outline"></i> New Registration</button>
  </div>
</div>

<h3 class="heading">Latest Registrations Worked On</h3>

<!-- Data -->
<nz-table *ngIf="dataSet && dataSet.length > 0" #claimSearchTable [nzData]="dataSet" [nzSize]="'middle'"
  [nzScroll]="{ x: '1500px'}">
  <thead>
    <tr>
      <th>Policy Number</th>
      <th>Reg. Number</th>
      <th>Reg. Date</th>
      <th>Insured Name</th>
      <th>Claimant Name</th>
      <th>Claimant Telephone</th>
      <th>Claimant email</th>
      <th>Intimation Date</th>
      <th>Claim Status</th>
      <th>Event Type</th>
    </tr>
  </thead>
  <tbody>
    <tr *ngFor="let data of claimSearchTable.data">
      <td>{{data.policyNum}}</td>
      <td> <a (click)="openTransactionDetails('claimRegistration',data.guid,'workbench')">{{data.claimNum}}</a></td>
      <td>{{getDateString(data.receivedDt)}}</td>
      <td>{{data.insuredFirstName }} {{data.insuredLastName}} </td>
      <td>{{data.claimantFirstName }} {{data.claimantLastName}} </td>
      <td>{{data.claimantPhNo}}</td>
      <td>{{data.claimantEmail}}</td>
      <td>{{getDateString(data.intimationDt)}}</td>
      <td>{{data.statusCd}}</td>
      <td>{{data.eventType}}</td>
    </tr>
  </tbody>
</nz-table>
<app-generic-zero-ui [list]="dataSet" icon="file-search" [title]="registrationZeroState.title"
  [message]="registrationZeroState.message" [icon]="registrationZeroState.icon"></app-generic-zero-ui>
